import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fullDesktopMediaQuery, desktopMediaQuery, tabletMediaQuery, maxDesktopMediaQuery } from './sizes';

/*
 * Mixins
 */

export var transition = function transition() {
  var trans = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0.2s';
  var effect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ease';
  return _objectSpread({}, Array.isArray(trans) ? {
    transition: trans.map(function (v) {
      return "".concat(v, " ").concat(duration, " ").concat(effect);
    }).join(', ')
  } : {
    transition: "".concat(trans, " ").concat(duration, " ").concat(effect)
  });
};
export var svgColor = function svgColor(color) {
  var transitionProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    '& *[fill]:not([fill="none"]):not(.no-fill)': {
      fill: color,
      extend: transitionProperties ? transition('fill', transitionProperties.duration, transitionProperties.effect) : null
    },
    '& *[stroke]:not([stroke="none"]):not(.no-stroke)': {
      stroke: color,
      extend: transitionProperties ? transition('stroke', transitionProperties.duration, transitionProperties.effect) : null
    },
    '& path': {
      extend: transitionProperties ? transition('fill', transitionProperties.duration, transitionProperties.effect) : null
    }
  };
};
export var placeholder = function placeholder(color) {
  var font = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var getPlaceHolder = function getPlaceHolder(c, f) {
    return {
      '& [placeholder], &::placeholder': _objectSpread({
        color: c
      }, f)
    };
  };
  if (typeof color === 'function') {
    return _objectSpread({}, getPlaceHolder(color, font));
  }
  return getPlaceHolder(color, font);
};
export var aspectRatio = function aspectRatio(width, height) {
  return {
    width: '100%',
    paddingTop: "".concat(height / width * 100, "%"),
    position: 'relative',
    height: 0,
    '& > *': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  };
};

/*
 * This project use mobile first integration
 * Default media is mobile
 */

export var tablet = function tablet(content) {
  return _defineProperty({}, tabletMediaQuery, _objectSpread({}, content));
};
export var desktop = function desktop(content) {
  return _defineProperty({}, desktopMediaQuery, _objectSpread({}, content));
};
export var fullDesktop = function fullDesktop(content) {
  return _defineProperty({}, fullDesktopMediaQuery, _objectSpread({}, content));
};
export var maxDesktop = function maxDesktop(content) {
  return _defineProperty({}, maxDesktopMediaQuery, _objectSpread({}, content));
};